import { useEffect, useState } from 'react'
import { Box, Heading, Text, VStack, HStack, Button, FormControl, FormLabel, Input, SimpleGrid, useToast, Spinner } from '@chakra-ui/react'
import { Save } from 'lucide-react'
import axios from 'axios'

export default function AdminPricing() {
  const [pricing, setPricing] = useState([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const toast = useToast()

  useEffect(() => { axios.get('/api/admin/pricing').then(r => setPricing(r.data)).finally(() => setLoading(false)) }, [])

  const update = (plan, field, value) => setPricing(prev => prev.map(p => p.plan === plan ? { ...p, [field]: value } : p))

  const handleSave = async (plan) => {
    const config = pricing.find(p => p.plan === plan)
    setSaving(true)
    try {
      await axios.post('/api/admin/pricing', { plan: config.plan, price_usd: parseFloat(config.price_usd), trial_days: parseInt(config.trial_days) })
      toast({ title: 'Pricing updated', status: 'success', duration: 2000 })
    } catch { toast({ title: 'Failed to update pricing', status: 'error', duration: 3000 }) }
    finally { setSaving(false) }
  }

  if (loading) return <Box p={8}><Spinner color="brand.orange" /></Box>

  return (
    <Box p={8} maxW="600px">
      <Heading size="lg" fontFamily="Georgia, serif" color="brand.darkBlue" mb={2}>Pricing Control</Heading>
      <Text fontSize="14px" color="gray.500" mb={8}>Adjust subscription prices anytime. Changes take effect immediately for new subscribers.</Text>
      <VStack spacing={5} align="stretch">
        {pricing.map(p => (
          <Box key={p.plan} bg="white" borderRadius="12px" border="1px solid #E2E2E2" p={6}>
            <Heading size="sm" fontFamily="Georgia, serif" color="brand.darkBlue" mb={4} textTransform="capitalize">
              {p.plan.replace('_', ' ')} Plan
            </Heading>
            <SimpleGrid columns={2} spacing={4} mb={4}>
              <FormControl>
                <FormLabel fontSize="13px" fontWeight="500" color="gray.600">Price (USD/month)</FormLabel>
                <Input value={p.price_usd} onChange={e => update(p.plan, 'price_usd', e.target.value)} type="number" borderColor="#E2E2E2" _focus={{ borderColor: 'brand.orange' }} size="sm" />
              </FormControl>
              <FormControl>
                <FormLabel fontSize="13px" fontWeight="500" color="gray.600">Trial days</FormLabel>
                <Input value={p.trial_days} onChange={e => update(p.plan, 'trial_days', e.target.value)} type="number" borderColor="#E2E2E2" _focus={{ borderColor: 'brand.orange' }} size="sm" />
              </FormControl>
            </SimpleGrid>
            <Button size="sm" variant="primary" leftIcon={<Save size={13} />} onClick={() => handleSave(p.plan)} isLoading={saving}>Save Changes</Button>
          </Box>
        ))}
      </VStack>
    </Box>
  )
}
